import * as yup from 'yup';
import { HoverImageCards } from '@web/components';
import { inlineRichTextFromCMSSchema, linkSchema } from '../schemas';
import { schema as hoverImageCardSchema } from './hover_image_card';

export const component = HoverImageCards;

export const schema = yup
  .object({
    headline: yup.string().nullable(),
    subheadline: inlineRichTextFromCMSSchema,
    items: yup.array(hoverImageCardSchema).required(),
    isCarousel: yup.bool(),
    link: linkSchema,
    backgroundColor: yup.string(),
    fontColor: yup.string(),
    eyebrow: yup.string().nullable(),
    level: yup.string().nullable(),
    typography: yup.string().nullable(),
    headerText: yup.string(),
  })
  .transform(value => ({
    headline: value.headline,
    subheadline: value.subheadline,
    items: value.items,
    isCarousel: value.is_carousel,
    link: value.link[0],
    backgroundColor: value.background_color || undefined,
    fontColor: value.fontColor || undefined,
    eyebrow: value.eyebrow,
    level: value.level,
    typography: value.typography || undefined,
    headerText:
      value.headline || value.subheadline?.content[0]?.content[0]?.text,
  }));
